import BlogCover from '@/components/BlogCover';

import coverImage from './images/cover.png';
import profileImage from './images/profile.png';

const Component: React.FC = () => (
  <BlogCover
    title="板垣孝司ブログ"
    coverImage={coverImage}
    profileImage={profileImage}
    description="ドイツ1部監督。青森山田前監督"
  />
);

export default Component;
